import { call, put, takeLatest, delay, select, takeEvery } from "redux-saga/effects"

import { JOB_STATUS_PENDING } from "../types/index"

function* jobsFlow(action) {}

function* jobsWatcher() {
	yield takeEvery(JOB_STATUS_PENDING, jobsFlow)
}

export default jobsWatcher
